const updateVariantInputId = (variantsContainer: HTMLElement, variantId: number): void => {
  const variantInputIdEl = variantsContainer.querySelector<HTMLInputElement>('[data-product-variants-id]');
  if (!variantInputIdEl) return;
  variantInputIdEl.value = String(variantId);
};

export default updateVariantInputId;
